import BaseCustomizer from '../base';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';

export default class EnrollTotpCustomizer extends BaseCustomizer {
  async shouldCustomize() {
    return [ 'enroll-totp' ].includes(this.context?.controller);
  }

  async customize() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['GOOGLE']}TotpEnroll::Landing`);
    // Navigate to the barcode scan step directly.
    jQueryCourage('.auth-content').css('opacity', '0');
    this.clickAppleRadioButton();
    this.clickNextButton();
  }

  private clickAppleRadioButton() {
    jQueryCourage('.custom-radio input[value="APPLE"]').trigger('click');
  }

  private clickNextButton() {
    jQueryCourage('.button-primary').trigger('click');
  }
}
